require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/addScript.js")(require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/node_modules/raw-loader/index.js!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/site/web/js/tracking/mixpanel_manager.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./js/tracking/mixpanel_manager.js
 ** module id = 36
 ** module chunks = 8
 **/